/* eslint-disable react/button-has-type */
import React from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import injectSheet from 'react-jss';
import { colourThemeType } from '../../../../propTypes';
import theme from '../../../../styles/theme';

const Button = ({
  disabled, text, classes, type, href, colourTheme,
}) => (
  <div className={classes.button}>
    {href
      ? (
        <a href={href}>
          {colourTheme.backgroundColor}
          {text}
        </a>
      )
      : (
        <button type={type} disabled={disabled}>
          {colourTheme.backgroundColor}
          {text}
        </button>
      )}
  </div>
);

Button.defaultProps = {
  type: 'submit',
  href: null,
  disabled: false,
};

Button.propTypes = {
  href: PropTypes.string,
  type: PropTypes.string,
  disabled: PropTypes.bool,
  text: PropTypes.string.isRequired,
  classes: PropTypes.objectOf(PropTypes.string).isRequired,
  // eslint-disable-next-line react/no-unused-prop-types -- used in the styles
  colourTheme: colourThemeType.isRequired,
};

export default compose(
  injectSheet({
    button: {
      display: 'flex',
      justifyContent: 'center',
      '& > button, & > a': {
        margin: `${theme.spacing.vertical.xxs}px 0`,
        padding: `${theme.spacing.vertical.xs}px ${theme.spacing.vertical.md}px`,
        textTransform: 'uppercase',
        backgroundColor: theme.colors.transparent,
        color: 'inherit',
        border: '1px solid currentColor',
        borderRadius: '2px',
        textDecoration: 'none !important',
        transition: 'all 0.2s ease',
        fontSize: '14px',
        fontWeight: 'bold',
        '&:hover, &:focus, &:active': {
          backgroundColor: ({ colourTheme }) => colourTheme.buttonHover.backgroundColour,
          borderColor: ({ colourTheme }) => colourTheme.buttonHover.backgroundColour,
          backgroundImage: 'none',
          color: ({ colourTheme }) => colourTheme.buttonHover.textColour,
        },
        [theme.breakpoints.down('md')]: {
          padding: `${theme.spacing.vertical.xs}px ${theme.spacing.vertical.sm}px`,
        },
      },
    },
  }),
)(Button);
